import {
  GET_ALL_ROLES_RESPONSE_SUCCESS,
  DELETE_ROLE_RESPONSE_ERROR,
} from "./actionTypes"
import { combineReducers } from "redux"

const Index = (state = [], action) => {
  const { payload } = action
  switch (action.type) {
    case GET_ALL_ROLES_RESPONSE_SUCCESS:
      return payload

    default:
      return state
  }
}

const roles = combineReducers({
  Index,
})

export default roles
